module.exports = __webpack_public_path__ + "img/speak_no_evil.8e57cded.png";